<template>
    <div class='dms-wrap'>
    <div class='dms-sidebar'>
        <div class='dms-sidebar__tabs'>
            <div class='tab' data-tar='my-messages'><span>My Messages</span>
                <small v-if="conversations.filter(conversation => conversation.pivot.read == 0).length > 0"><span>{{ conversations.filter(conversation => conversation.pivot.read == 0).length }}</span></small>
            </div>
        </div>
        <div class='dms-sidebar-tab' id='dms-my-messages'>
            <form class='dms-sidebar__form'>
                <button type='submit'><svg class='search'><use xlink:href="#search"></use></svg></button>
                <input type="text" v-model="search" placeholder="Search">
            </form>
            <ul class='dms-sidebar__people' v-if="conversations.length > 0" @scroll="handleScroll">
                <li v-for="conversation in filteredConversations" v-on:click="showConversation(conversation)" :class="conversation.active ? 'active' : '' " v-if="!conversation.pivot.deleted">
                    <img v-for="convo_user in conversation.users" v-if="convo_user.id != user.id" v-bind:src="convo_user.large_profile" data-rjs="2">
                    <div class='content'>
                        <span v-if="!conversation.pivot.read">New</span>
                        <h2>
                            <span v-for="convo_user in conversation.users" v-if="convo_user.id != user.id" class='person-hover-trigger' :data-user="convo_user.username">
                                {{convo_user.first_name}} {{convo_user.last_name}}<svg v-if="convo_user.is_verified" class='verified-badge' aria-labelledby="badgeTitle">
                            <title id="badgeTitle">Well Traveled Insider</title>
                            <use xlink:href="#verified-badge"><title id="badgeTitle">Well Traveled Insider</title></use>
                        </svg>
                            </span>
                            <small>{{ localTimeAgo(conversation.pivot.updated_at) }}</small>
                        </h2>
                        <p>{{conversation.last_message}}</p>
                    </div>
                </li>
                <li v-if="loadingConversations">
                    <div class='content'>
                        <h2 class="loading">
                            Loading<span id="wait">.</span>
                        </h2>
                    </div>
                </li>
<!--                <li v-if="noResults">-->
<!--                    <div class='content'>-->
<!--                        <h2 class="loading">-->
<!--                            No Results-->
<!--                        </h2>-->
<!--                    </div>-->
<!--                </li>-->
            </ul>

            <div class='dms-main__empty mobile' v-if="conversations.length == 0">
                <div class='inner'>
                    <svg class='message-alt'><use xlink:href="#message-alt"></use></svg>
                    <h2>Messages</h2>
                    <p>Connect with fellow Well Traveled members.</p>
                </div>
            </div>
        </div>
        <div class='dms-sidebar__button'>
            <span class='compose-message-trigger'><svg class='message'><use xlink:href="#message"></use></svg>Compose Message</span>
        </div>
    </div>
    <div class='dms-main' :class="showConvo ? 'active' : ''">

        <div class='dms-main__empty' v-if="!showConvo">
            <div class='inner'>
                <svg class='message-alt'><use xlink:href="#message-alt"></use></svg>
                <h2>Messages</h2>
                <p>Connect with fellow Well Traveled members.</p>
                <span class='compose-message-trigger'>Compose Message</span>
            </div>
        </div>

        <div class='dms-conversation' v-if="showConvo">
            <div class='dms-conversation__header'>
                <span class='hide-conv-trigger' v-on:click="hideConvoWindow()"><svg class='arrow-right'><use xlink:href="#arrow-right"></use></svg></span>
                <a v-for="convo_user in selectedConvo.users" v-if="convo_user.id != user.id" v-bind:href="'/'+convo_user.username" class='person-hover-trigger' :data-user="convo_user.username">
                    <img class='' v-bind:src="convo_user.profile_thumbnail">
                    <span>{{convo_user.first_name}} {{convo_user.last_name}}<svg v-if="convo_user.is_verified" class='verified-badge'><use xlink:href="#verified-badge"></use></svg></span>
                </a>
                <div class='controls'>
                    <span class='conv-dd-trigger' v-on:click="openConversationActions()">
                        <svg class='dotdotdot'><use xlink:href="#dotdotdot"></use></svg>
                    </span>
                    <div class='conv-dd'>
                        <a v-bind:href="'/'+selectedConvo.users[0].username">View Profile</a>
                        <a href='#' v-on:click="deleteThread()">Delete Thread</a>
                        <a href='#' v-on:click="blockUser()">Block User</a>
                    </div>
                </div>
            </div>
            <div class='dms-conversation__messages' ref="messages" v-on:scroll='messagesScroll()'>
                <div class='conv-day' v-for="(messages, day, index) in conversation_messages">
                    <div class='conv-day-wrap'>
                        <span>{{ [ day, "YYYY-MM-DD" ] | moment("MMMM D") }}</span>
                    </div>
                    <div class='conv-person' v-for="message in messages">
                        <a v-bind:href="'/'+users[message.user_id].username" class='img-cta'>
                            <img v-bind:src="users[message.user_id].large_profile">
                        </a>
                        <h2>
                            <div class='person-hover-trigger' :data-user="users[message.user_id].username">{{users[message.user_id].first_name}} {{users[message.user_id].last_name}}<svg v-if="users[message.user_id].is_verified" class='verified-badge'><use xlink:href="#verified-badge"></use></svg></div>
                            <span>{{ localMoment(message.created_at, "h:mma") }}</span>
                        </h2>
                        <div class="message" style="white-space: break-spaces;">
                            <p  v-html="message.message" v-linkified></p>
                        </div>
                    </div>
                    <div class='conv-person' v-if="!selectedConvo.pivot.accepted">
                        <div class='blocker'>
                            <h2>{{otherUserName}} wants to send you a message</h2>
                            <p>They won't be notified if you deny.</p>
                            <div class='controls'>
                                <span v-on:click="acceptConversation()">Accept +</span>
                                <span v-on:click="blockConversation()">Deny -</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='conv-person' v-if="deleteThreadConfirm">
                    <div class='blocker'>
                        <h2>Are you sure your want to delete thread?</h2>
                        <p>{{otherUserName}} will still see the thread.</p>
                        <div class='controls'>
                            <span v-on:click="deleteConversation()">Delete</span>
                            <span v-on:click="deleteThreadConfirm = false">Cancel</span>
                        </div>
                    </div>
                </div>
                <div class='conv-person' v-if="blockUserConfirm">
                    <div class='blocker'>
                        <h2>Are you sure your want to block {{otherUserName}}?</h2>
                        <p>{{otherUserName}} won't be able to send you any messages.</p>
                        <div class='controls'>
                            <span v-on:click="blockConversation()">Block</span>
                            <span v-on:click="blockUserConfirm = false">Cancel</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class='dms-conversation__chatbox' v-if="selectedConvo.pivot.accepted">
                <form>
<!--                    <input type="text" id="dm-message" :placeholder="[[messagePlaceholder]]" v-model="message" >-->
                    <textarea id="dm-message"
                              placeholder="Write a message..."
                              @keyup.enter.exact="sendMessage()"
                              oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"' v-model="message"></textarea>
                    <button @click.prevent="sendMessage()">
                        Send
                    </button>
                </form>
            </div>
        </div>

    </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { eventBus } from "../../dms";

export default {

    props: ['iconversations', 'itotalconversations', 'iuser', 'iexclude'],

    data() {
        return {
            // noResults: true,
            conversations: this.iconversations,
            showConvo: false,
            selectedConvo: '',
            message: '',
            conversation_messages: '',
            users: [],
            otherUserName: '',
            deleteThreadConfirm: false,
            blockUserConfirm: false,
            search: '',
            addingConvo: false,
            messagePlaceholder: '',
            timezone: '',
            totalConversations: this.itotalconversations,
            exclude: this.iexclude,
            loadingConversations: false,
            initConversation: false,
            loadedConvos: 15,
            conversationsAlreadyLoaded: [],
            user: this.iuser,
            searching: false,
            lastSearch: ''
        }
    },

    mounted() {

        this.conversations.forEach((conversation, index) => {
            this.conversationsAlreadyLoaded.push(conversation.id)
        });

        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        if (this.$route.query.conversation) {
            this.initConversation = true;
            let conversation_exists = false;
            let set_conversation = false;
            this.conversations.forEach((conversation, index) => {
                conversation.users.forEach((user, index) => {
                    if (this.$route.query.conversation == user.username) {
                        set_conversation = conversation;
                        conversation_exists = true;
                    }
                });
            });

            if (conversation_exists)
                this.showConversation(set_conversation);
        }

        eventBus.$on('createConversation', (convo_user) => {


            //Check if conversation exists in frontend.
            let conversation_exists = false;
            let set_conversation = false;
            this.conversations.forEach((conversation, index) => {
                conversation.users.forEach((user, index) => {
                    if (convo_user[0] == user.id) {
                        set_conversation = conversation;
                        conversation_exists = true;
                    }
                });
            });

            //Check if conversation exists in backend.

            if (!conversation_exists) {
                axios.post('/conversations-check-exist', {user_id: convo_user[0]})
                    .then((response) => {
                        console.log(response.data)
                        if (response.data.id) {
                            this.conversations.map(e => Vue.set(e, 'active', false))
                            this.conversations.push(response.data);
                            this.conversationsAlreadyLoaded.push(response.data.id);
                            this.showConversation(response.data);
                            this.listenForNewMessage(response.data);
                            setTimeout(function () {
                                    var $container = $('.dms-sidebar__people'),
                                        $scrollTo = $('.dms-sidebar__people li.active');
                                    $container.scrollTop(
                                        $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                                    );
                                }
                                , 500);
                        } else {
                            if (!this.addingConvo) {
                                this.addingConvo = true;
                                axios.post('/conversations', {users: convo_user})
                                    .then((response) => {
                                        this.users = [];
                                        this.conversations.unshift(response.data);
                                        this.showConversation(response.data);
                                        this.listenForNewMessage(response.data);
                                        this.addingConvo = false;
                                        this.conversationsAlreadyLoaded.push(response.data.id)
                                    });
                            } else {
                                this.showConversation(set_conversation);
                            }
                        }

                    });
            }

            /*
            if (!this.addingConvo) {
                if (!conversation_exists) {
                    this.addingConvo = true;
                    axios.post('/conversations', {users: convo_user})
                        .then((response) => {
                            this.users = [];
                            this.conversations.unshift(response.data);
                            this.showConversation(response.data);
                            this.listenForNewMessage(response.data);
                            this.addingConvo = false;
                        });
                } else
                    this.showConversation(set_conversation);
            }
            */

            $('.endorsed-modal__dms').fadeOut();
        });

        this.listenForNewConversation();
        this.conversations.forEach((conversation, index) => {
            this.listenForNewMessage(conversation);
        });

        /*
        var dots = window.setInterval( function() {
            var wait = document.getElementById("wait");
            if ( wait.innerHTML.length > 3 )
                wait.innerHTML = "";
            else
                wait.innerHTML += ".";
        }, 300);
        */

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('thread')) {
            let conversationId = urlParams.get('thread');
            console.log(conversationId)
            let conversation = _.find(this.conversations, c => c.id == conversationId)
            if (conversation) {
                console.log(conversation)
                this.showConversation(conversation)
            }
        }
    },

    computed: {
        filteredConversations() {
            let searchtext = this.search.toLowerCase();
            var searchConvos = this.conversations.filter(function (conversation) {
                return conversation.users[0].first_name.toLowerCase().includes(searchtext) || conversation.users[0].last_name.toLowerCase().includes(searchtext) || conversation.users[1].first_name.toLowerCase().includes(searchtext) || conversation.users[1].last_name.toLowerCase().includes(searchtext)
            }).sort(function (cona, conb) {
                var a = conb.pivot.updated_at.replace(" ", "T")
                var b = cona.pivot.updated_at.replace(" ", "T")
                b = new Date(b).getTime();
                a = new Date(a).getTime();
                var r = ((a > b) ? 1 : ((a < b) ? -1 : 0));
                if (r === 0) {
                    r = (typeof cona.id !== 'undefined' && typeof conb.id !== 'undefined') ?
                        cona.id - conb.id : 0;
                }
                return r;
            })

            //if(searchConvos.length == 0)
            this.searchServer(searchtext);

            return searchConvos;
        }
    },

    methods: {

        handleScroll(el) {
            if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
                if (!this.loadingConversations && (this.loadedConvos < this.totalConversations)) {
                    this.loadingConversations = true;
                    axios.post('/load-conversations', {counter: this.loadedConvos, exclude: this.exclude, loaded: this.conversationsAlreadyLoaded})
                        .then((response) => {
                            this.loadedConvos += 15;
                            this.loadingConversations = false;
                            Object.keys(response.data).forEach(key => {
                                this.conversations.push(response.data[key]);
                                this.conversationsAlreadyLoaded.push(response.data[key].id)
                            })
                        })
                }
            }
        },

        searchServer(searchtext) {

            if (searchtext.length < 3)
                return false;

            if (this.lastSearch == searchtext) {
                return false;
            }

            //this.noResults = false;
            this.lastSearch = searchtext;

            if (this.searching)
                return false;

            this.searching = true;
            axios.post('/search-conversations', {search: searchtext, exclude: this.exclude, loaded: this.conversationsAlreadyLoaded})
                .then((response) => {

                    // if(response.data.length > 0) {
                    //     this.noResults = false
                    // }

                    this.searching = false;
                    Object.keys(response.data).forEach(key => {
                        this.conversations.push(response.data[key]);
                        this.conversationsAlreadyLoaded.push(response.data[key].id)
                    })
                })
        },

        loadConversations() {
            /*
            let promises = [];
            for (var i = 15; i <= this.totalConversations; i+= 15) {
                promises.push(
                    axios.post('/load-conversations', {counter: i,exclude: this.exclude})
                        .then((response) => {
                            Object.keys(response.data).forEach(key => {
                                this.conversations.push(response.data[key]);
                            })
                        })
                )
            }

            let conversation_set = this.$route.query.conversation;
            Promise.all(promises).then(
                data =>{
                    this.loadingConversations = false;
                    if (typeof conversation_set !== 'undefined')
                    {
                        var $container = $('.dms-sidebar__people'),
                            $scrollTo = $('.dms-sidebar__people li.active');
                        $container.scrollTop(
                            $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                        );
                    }
                }
            );
            */
        },

        localMoment(date, format) {
            return this.$moment.utc(date).local().format(format);
        },

        localTimeAgo(date) {
            return this.$moment.utc(date).local().fromNow();
        },

        openConversationActions() {
            $('.conv-dd').fadeToggle();
        },

        deleteThread() {
            this.blockUserConfirm = false;
            this.deleteThreadConfirm = true;
            this.scrollToMessages();
            this.openConversationActions();
        },

        deleteConversation() {
            this.deleteThreadConfirm = false;
            this.showConvo = false;
            this.selectedConvo.pivot.deleted = true;
            this.updateConversation();
        },

        blockUser() {
            this.deleteThreadConfirm = false;
            this.blockUserConfirm = true;
            this.scrollToMessages();
            this.openConversationActions();
        },

        blockConversation() {
            this.showConvo = false;
            this.selectedConvo.pivot.blocked = true;
            this.selectedConvo.pivot.deleted = true;
            this.updateConversation();
        },

        hideConvoWindow() {
            $('.endorsed-modal__dms').hide();
            this.showConvo = false;
        },

        scrollToMessages() {
            setTimeout(() => this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight, 100);
        },

        listenForNewConversation() {
            Echo.private('users.' + this.user.id)
                .listen('ConversationCreated', (e) => {
                    axios.get('/conversations/' + e.id)
                        .then((response) => {
                            this.conversations.push(response.data);
                            this.listenForNewMessage(response.data);
                        });
                });
        },

        updateConversation() {
            axios.post('/conversation/status', {conversation: this.selectedConvo})
                .then((response) => {
                });
        },

        acceptConversation() {
            this.selectedConvo.pivot.accepted = true;
            this.updateConversation();
        },

        showConversation(conversation) {
            this.conversations.map(e => Vue.set(e, 'active', false))
            conversation.pivot.read = true;

            this.selectedConvo = conversation;
            this.showConvo = true;

            this.deleteThreadConfirm = false;
            this.blockUserConfirm = false;

            this.users = [];
            this.otherUserName = '';
            this.selectedConvo.users.forEach((convo_user, index) => {
                this.users[convo_user.id] = convo_user;
                if (convo_user.id != this.user.id)
                    this.otherUserName = convo_user.first_name;
            });

            //Load in messages
            axios.post('/get-all-messages', {conversation_id: this.selectedConvo.id, user_timezone: this.timezone})
                .then((response) => {
                    this.conversation_messages = response.data;
                    this.scrollToMessages();

                    if (this.conversation_messages.length == 0)
                        this.messagePlaceholder = 'Write a message...';
                    else
                        this.messagePlaceholder = 'Start a Reply...';
                });

            //Set Conversation Status
            this.updateConversation();
            conversation.active = true;
            this.initConversation = false;

        },

        sendMessage() {

            if (this.message == '')
                return false;

            this.messagePlaceholder = 'Start a Reply...';

            let postMessage;
            postMessage = this.message;
            this.message = '';
            axios.post('/messages', {message: postMessage, conversation_id: this.selectedConvo.id, user_timezone: this.timezone})
                .then((response) => {

                    if (this.conversation_messages == '') {
                        this.selectedConvo.last_message = response.data.last_message;
                        this.showConversation(this.selectedConvo)
                    } else
                        this.addMessage(response.data);

                });
        },

        listenForNewMessage(conversation) {
            Echo.private('conversation.' + conversation.id)
                .listen('NewMessage', (e) => {

                    if (e.conversation_id == this.selectedConvo.id) {
                        this.selectedConvo.pivot.updated_at = e.date;
                        this.selectedConvo.pivot.updated_at = e.date;

                        //Load in messages
                        axios.post('/get-message', {message_id: e.message_id, user_timezone: this.timezone})
                            .then((response) => {
                                this.addMessage(response.data);
                                if (!this.selectedConvo.pivot.blocked)
                                    this.selectedConvo.pivot.deleted = false;
                            });
                    } else {
                        this.conversations.forEach((conversation, index) => {
                            if (e.conversation_id == conversation.id) {
                                conversation.pivot.read = 0;
                                conversation.pivot.updated_at = e.date;
                                conversation.last_message = e.last_message;
                                if (!conversation.pivot.blocked)
                                    conversation.pivot.deleted = false;
                            }
                        });
                    }

                    /*
                    Notification.requestPermission( permission => {
                        let notification = new Notification('You got a new message', {
                            body: e.last_message,
                        });

                        // link to page on clicking the notification
                        notification.onclick = () => {
                            window.open(window.location.href);
                        };
                    });
                    */
                });
        },

        addMessage(message) {
            if (typeof this.conversation_messages[message.date] === 'undefined')
                this.conversation_messages[message.date] = []
            this.conversation_messages[message.date].push(message);

            this.selectedConvo.last_message = message.last_message;
            this.selectedConvo.pivot.updated_at = message.updated_at;

            this.scrollToMessages();
        },

        messagesScroll() {

            var scroll = $(this).scrollTop();
            var top;
            var bot;

            $('.conv-day').each(function () {

                top = $(this).position().top;
                bot = top + $(this).outerHeight();

                if (top <= 0) {

                    console.log('Greater than top: ', $(this));

                    if (bot <= 0) {

                        $(this).removeClass('fixed').addClass('bot');

                    } else {

                        $(this).removeClass('bot').addClass('fixed');

                    }

                } else {

                    $(this).removeClass('fixed bot');

                }

            });

        }

    }
}
</script>
